import { DownloadSimpleIcon, FilePdfIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { Typography } from '@/components/ui/typography'
import { getAssetLink } from '@/helpers/get-asset-link'

import * as S from '../reservations-details.styled'

interface Props {
  agreement?: string | null
  isLoading?: boolean
}

export const Documents = ({ agreement, isLoading }: Props) => {
  const { t } = useTranslation(['reservations'])
  const location = useLocation()

  const handleDownloadAgreement = (agreement?: string | null) => {
    if (!agreement) {
      return
    }

    const link = document.createElement('a')
    link.href = getAssetLink({ file: agreement, path: 'reservation_agreements' })
    link.target = '_blank'
    link.download = 'agreement.pdf'
    link.click()
  }

  if (!isLoading && !agreement) {
    return <Navigate replace to={location.pathname} />
  }

  return (
    <S.CompactCard>
      <S.BasicInfo>
        <FilePdfIcon />
        <Typography size="heading-small" weight="bold">
          {t('reservations:details.documents.documents')}
        </Typography>
      </S.BasicInfo>

      <S.Table>
        <S.Row>
          <S.DocumentRow>
            <S.DocumentIcon>
              <FilePdfIcon />
            </S.DocumentIcon>
            <div>
              <Typography size="text-medium" weight="bold">
                {agreement}
              </Typography>
              <Typography size="text-small">PDF</Typography>
            </div>
          </S.DocumentRow>
          <Button
            onlyBox
            use="secondary"
            size="small"
            disabled={!agreement}
            onClick={() => handleDownloadAgreement(agreement)}
          >
            <DownloadSimpleIcon />
          </Button>
        </S.Row>
      </S.Table>
    </S.CompactCard>
  )
}
